<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="alert alert-info" role="alert">
          <p>Obs.: As solicitações com Projetos/Comprovantes não enviados são CANCELADAS automaticamente em 120 dias.</p>
        </div>

        <div class="alert alert-success" role="alert">
          <p>Visualizando todos. Desmarque o filtro "Ver todas Solicitações" para mostrar somente os últimos 30 dias.</p>
        </div>
      </div>
    </div>    
    <div class="row">
      <div class="col-md-12">
        <div class="choose-checkbox-methods">
          <label class="checkbox-option">
            <input v-model="formFilter.mostrarTodas" name="Mostrartodos" type="checkbox">
            <span>Mostrar todas as solicitações</span>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <FormHelper
          :inputVar="formFilter.situacao"
          :form="formFilter"
          :options="optionsfilters()"
          type="select"
          label="Filtrar por Situação"
          placeholder="Selecione"
        ></FormHelper>
      </div>
      <div class="col-md-2">
        <div class="wrap-butons-line2">
          <button @click.prevent="consultar" aria-label="Consultar" class="btn btn-primary">
            <i class="fa fa-search"></i> Consultar
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <vue-good-table
          :columns="columns"
          :rows="dados"
          :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 20,
                position: 'top',
                perPageDropdown: [40, 60],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'Próximo',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Linhas por página',
                ofLabel: 'de',
                pageLabel: 'page',
                allLabel: 'Todos',
            }"
        >
          <template slot="table-row" slot-scope="props">
            <span
              v-if="props.column.field == 'valor'"
            >{{ formatCurrency(props.formattedRow[props.column.field]) }}</span>
            <a
              v-else-if="props.column.field == 'id'"
              :href="`${$SiteUrl}/loja/crazy-card/resgate/detalhe/${props.formattedRow[props.column.field]}`"           
            >
              <i class="fa fa-eye"></i>
            </a>
            <span v-else>{{props.formattedRow[props.column.field]}}</span>
          </template>
          <div slot="emptystate">Sem dados para exibição</div>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import FormHelper from "../FormHelper.vue";

export default {
  name: "CrazyRescueFind",
  props: ["dados"],
  components: {
    VueGoodTable,
    FormHelper
  },

  data() {
    return {
      formFilter: {
        situacao: new this.formInput(),
        mostrarTodas: false
      },
      columns: [
        {
          label: "Ver",
          field: "id",
          tdClass: "align-center-td",
          thClass: "align-center-td"
        },
        { label: "Número", field: "nr" },
        { label: "Situação", field: "situacao" },
        { label: "Data", field: "data" },
        { label: "Valor", field: "valor", type: "decimal" }
      ]
    };
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  mounted() {
    if (localStorage.Resgates.length > 0){      
      this.dados = []
      let json = JSON.parse(localStorage.Resgates)
      json.forEach((element) => {
        let dado = {}
        dado.id = element.CodigoSolicitacao
        dado.nr = element.CodigoSolicitacao
        dado.situacao = element.Descricao
        dado.data = element.Data
        dado.valor = element.ValorTotal.replace(",00", "")
        this.dados.push(dado) 
      })
    }
  },
  methods: {
    formInput: function(required, value) {
      // Define um padrão para estrutura de cada input do formulário
      this.required = required !== undefined ? required : true;
      this.value = value !== undefined ? value : "";

      this.validation = {
        // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !this.required,
        message: this.required ? "Por favor, preencha o campo acima" : ""
      };
    },
    formatCurrency: function(v) {
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato).replace("R$", "A$");
    },
    optionsfilters() {
      const values = [
        {
          code: "0",
          label: "Todas"
        },
        {
          code: "1",
          label: "Em digitação"
        },
        {
          code: "2",
          label: "Aprovada"
        },
        {
          code: "3",
          label: "Aguardando Aprovação"
        },
        {
          code: "4",
          label: "Projeto/Comprovante Não Enviado"
        },
        {
          code: "5",
          label: "Projeto/Comprovante Recusado"
        },
        {
          code: "6",
          label: "Cancelada"
        }
      ];

      return values;
    },
    consultar() {
      this.dados = []

      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200){
          localStorage.Resgates = xhr.responseText;

          let json = JSON.parse(xhr.responseText)
          
          json.forEach((element) => {
            let dado = {}
            dado.id = element.CodigoSolicitacao
            dado.nr = element.CodigoSolicitacao
            dado.situacao = element.Descricao
            dado.data = element.Data
            dado.valor = element.ValorTotal.replace(",00", "")
            this.dados.push(dado) 
          })          
        }
        else if (xhr.status == 401){
          swal({
            title: "É necessário estar logado",
            icon: "warning"
          }).then(() => location.href = '/login?redirectTo=' + location.href)
        }
      }

      xhr.open("POST", this.$apiUrl + "Resgate.svc/beneficioresgate")
      xhr.setRequestHeader("Content-type", "application/json")
      xhr.withCredentials = true;
      xhr.send(JSON.stringify({
        verTodosRegistros: this.formFilter.mostrarTodas ? "S" : "N",
        situacao: this.formFilter.situacao.value.code
      }))
    }
  }
};
</script>

